// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1lMSG","col":"styles_col__3gx1A"};